import { httpAjax, baseAgent } from '@/api/ajax'
import { Encrypt } from "@/api/config"

const state = {
  // 用户信息数据
  userData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
  // 是否登陆
  isLogin: localStorage.getItem('userData') ? true : false,
  // 角色权限集合
  roles: []
}

const mutations = {
  // 设置角色
  setRoles: (state, roles) => {
    state.roles = roles
  },
  // 设置用户数据
  setUserData (state, data) {
    state.userData = data
  },
  // 修改登陆状态
  setIsLogin (state, data) {
    state.isLogin = data
  }
}

const actions = {
  // 登录
  login ({ commit }, userInfo) {
    const { userName, passWord, code } = userInfo
    return new Promise((resolve, reject) => {
      if (code) {
        baseAgent({
          url: `/services/auth/phoneLogin`,
          method: 'post',
          data: { phone: userName.trim(), verifyCode: code.trim() }
        }).then(response => {
          if (response.success) {
            const { data } = response
            localStorage.setItem('userData', JSON.stringify(data.user))
            localStorage.setItem('userToken', data.token)
            commit('setUserData', data.user)
            // 设置登录状态为false
            commit('setIsLogin', true)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      } else {
        httpAjax({
          url: '/services/auth/login',
          method: 'post',
          data: { username: userName.trim(), password: Encrypt(passWord) }
        }).then(response => {
          if (response.success) {
            const { data } = response
            // localStorage.setItem('userData', JSON.stringify(data.user));
            localStorage.setItem('userToken', data.token)
            // commit('setUserData', data.user);
            // 设置登录状态为false
            commit('setIsLogin', true)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      }

    })
  },

  // 二维码登录
  codeLogin ({ commit }, response) {
    return new Promise((resolve, reject) => {
      console.log(response.authInfo.user)
      localStorage.setItem('userData', JSON.stringify(response.authInfo.user))
      localStorage.setItem('userToken', response.authInfo.token)
      commit('setUserData', response.authInfo.user)
      // 设置登录状态为true
      commit('setIsLogin', true)
      resolve(response)
    })
  },

  // 注册
  register ({ commit }, params) {
    return new Promise((resolve, reject) => {
      httpAjax({
        url: '/services/user/register',
        method: 'post',
        data: params
      }).then(response => {
        if (response.success) {

        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('userData')) {
        reject('验证失败，请重新登录')
      }
      const userInfo = JSON.parse(localStorage.getItem('userData'))
      if (!userInfo.roles) {
        console.error('权限不能为空数组，否则路由死循环')
        return
      }
      // userInfo.roles = ['admin']
      commit('setRoles', ['admin']) // userInfo.roles
      resolve(userInfo)
    })
  },

  // 退出登录
  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // commit('setToken', '')
      // 清除用户数据
      commit('setUserData', '')
      // 清楚用户权限集合
      commit('setRoles', [])
      // 设置登录状态为false
      commit('setIsLogin', false)
      // 清除缓存的用户数据
      localStorage.removeItem('userData')
      localStorage.removeItem('userToken')
      // 清除缓存的多页签数据
      dispatch('tagsView/setRouterArr', [], { root: true })
      localStorage.removeItem('dataRouter')
      resolve()
    })
  },

  // 设置用户数据
  setUserData (context, data) {
    context.commit('setUserData', data)
  },
  // 从新获取用户信息
  getUserData (context, data) {
    return new Promise((resolve, reject) => {
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          context.commit('setUserData', response.data)
          localStorage.setItem('userData', JSON.stringify(response.data))
        }
        resolve(response)
      })
    })
  },
  // 修改登陆状态
  setIsLogin (context, data) {
    context.commit('setIsLogin', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
